"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const html_react_parser_1 = __importStar(require("html-react-parser"));
const material_1 = require("@mui/material");
// import app components
const ImageModal_1 = __importDefault(require("./ImageModal"));
const code_1 = __importDefault(require("../code"));
const theme_1 = require("../../../theme");
const gutterBottom = "20px";
const Textarea = (props) => {
    const { children, forceMobileImageFullWidth = true, disableCodeFormatting = false, h1 = "h1", h2 = "h2", h3 = "h3", h4 = "h4", h5 = "h5", h6 = "h6", p = "body1", linkComponent: Link, sx = {}, ...rest } = props;
    const contentRef = (0, react_1.useRef)(null);
    const [images, setImages] = (0, react_1.useState)([]);
    const [selectedImageIndex, setSelectedImageIndex] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        const handleImageClick = (event) => {
            const target = event.target;
            if (target && target.tagName === "IMG") {
                const img = target;
                const index = images.findIndex((image) => image.src === img.src);
                setSelectedImageIndex(index !== -1 ? index : null);
            }
        };
        const handleKeys = (event) => {
            if (typeof selectedImageIndex !== "number")
                return;
            if (event.key === "ArrowRight" && selectedImageIndex < images.length - 1) {
                setSelectedImageIndex(selectedImageIndex + 1);
            }
            else if (event.key === "ArrowLeft" && selectedImageIndex > 0) {
                setSelectedImageIndex(selectedImageIndex - 1);
            }
            else if (event.key === "Escape") {
                setSelectedImageIndex(null);
            }
        };
        const contentElem = contentRef.current;
        if (contentElem) {
            contentElem.addEventListener("click", handleImageClick);
            window.addEventListener("keydown", handleKeys);
        }
        return () => {
            if (contentElem) {
                contentElem.removeEventListener("click", handleImageClick);
            }
            window.removeEventListener("keydown", handleKeys);
        };
    }, [images, selectedImageIndex]);
    const contentString = typeof children === "string"
        ? children
            .trim()
            // remove default html tags, inserted by CherioJS
            .replace("<html>", "")
            .replace("</html>", "")
            .replace("<head>", "")
            .replace("</head>", "")
            .replace("<body>", "")
            .replace("</body>", "")
            // wrap table into div to make it responsive
            .replace(/<table/g, "<div class='table-wrapper'><table")
            .replace(/\/table>/g, "/table></div>")
            // wrap iframe into div to make it responsive
            .replace(/<iframe/g, "<div class='iframe-wrapper'><iframe")
            .replace(/\/iframe>/g, "/iframe></div>")
        : "";
    (0, react_1.useEffect)(() => {
        const extractImagesWithCaptions = () => {
            const contentElem = contentRef.current;
            if (!contentElem)
                return;
            const allImages = contentElem.querySelectorAll("img");
            const extractedImages = [];
            allImages.forEach((img) => {
                // Skip empty src tags
                if (img.src === window.location.href) {
                    return;
                }
                if (img.parentElement?.tagName === "FIGURE") {
                    const figcaption = img.parentElement.nextElementSibling;
                    if (figcaption?.tagName === "FIGCAPTION") {
                        const caption = figcaption.textContent?.trim();
                        extractedImages.push({ src: img.src, caption });
                    }
                    else {
                        extractedImages.push({ src: img.src });
                    }
                }
                else {
                    extractedImages.push({ src: img.src });
                }
            });
            setImages(extractedImages);
        };
        extractImagesWithCaptions();
    }, [contentString]);
    const options = {
        replace: (domNode) => {
            if ("name" in domNode && "attribs" in domNode) {
                if (Link &&
                    domNode.attribs?.href &&
                    !domNode.attribs.href.includes("http") &&
                    !domNode.attribs?.href.startsWith("#")) {
                    return react_1.default.createElement(Link, { href: domNode.attribs.href }, (0, html_react_parser_1.domToReact)(domNode.children));
                }
            }
            // Wrap code strings in <Code /> component
            if (!disableCodeFormatting &&
                "name" in domNode &&
                "attribs" in domNode &&
                domNode.attribs &&
                domNode.name === "pre" &&
                domNode?.children?.[0] &&
                domNode?.children?.[0] instanceof html_react_parser_1.Element &&
                domNode?.children?.[0]?.name === "code" &&
                // @ts-expect-error: Data property doesn't exist for domNode
                domNode?.children?.[0]?.children?.[0]?.data) {
                // @ts-expect-error: Data property doesn't exist for domNode
                return react_1.default.createElement(code_1.default, null, domNode.children[0].children[0].data);
            }
            return null;
        },
    };
    if (typeof children !== "string") {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.Box, { ref: contentRef, "data-testid": "textarea", ...rest, sx: {
                clear: "both",
                "&:after": {
                    content: "''",
                    display: "block",
                    clear: "both",
                },
                ...theme_1.mui.typography[p],
                "h1, h2, h3, h4, h5, h6": {
                    mb: gutterBottom,
                    mt: 0,
                    " &:not(:first-of-type)": {
                        mt: "2rem",
                    },
                },
                h1: {
                    ...theme_1.mui.typography[h1],
                },
                h2: {
                    ...theme_1.mui.typography[h2],
                },
                h3: {
                    ...theme_1.mui.typography[h3],
                },
                h4: {
                    ...theme_1.mui.typography[h4],
                },
                h5: {
                    ...theme_1.mui.typography[h5],
                },
                h6: {
                    ...theme_1.mui.typography[h6],
                },
                "p, ol, ul, figcaption, div": {
                    ...theme_1.mui.typography[p],
                    mb: gutterBottom,
                },
                a: {
                    color: theme_1.colors.primary[900],
                },
                img: {
                    cursor: "pointer",
                    boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
                },
                figcaption: { fontSize: "14px", lineHeight: "18px" },
                "ul, ol": {
                    ml: "25px",
                    mb: "40px",
                    pl: 0,
                    "ul, ol": { mb: gutterBottom },
                },
                "ul li": { listStyle: "disc" },
                ".wp-caption": {
                    marginTop: "30px",
                    mb: "30px",
                    textAlign: "center",
                    "@media (max-width: 599px)": { width: "100% !important" },
                    ".gatsby-image-wrapper,  > img": { mb: "10px !important" },
                    "&.alignright": {
                        "@media (min-width: 600px)": {
                            float: "right",
                            ml: "60px !important",
                        },
                    },
                    "&.alignleft": {
                        "@media (min-width: 600px)": {
                            float: "left",
                            marginRight: "60px !important",
                        },
                    },
                    "&.aligncenter": {
                        width: "100% !important",
                        ".wp-caption-text": { textAlign: "center" },
                    },
                },
                ".gatsby-image-wrapper > div > img[aria-hidden='true']": {
                    position: "absolute !important",
                },
                "img, figure, .gatsby-image-wrapper": {
                    maxWidth: "100%",
                    width: "100%",
                    height: "auto",
                    margin: "20px 0",
                    borderRadius: "15px",
                    "> .gatsby-image-wrapper": { mb: "20px" },
                    figcaption: { padding: "0 15px" },
                    "&.alignright": { float: "right", ml: "60px !important" },
                    "&.alignleft": { float: "left", marginRight: "60px !important" },
                    "&.size-medium": { width: "300px" },
                    "&.size-thumbnail": { width: "150px" },
                    "&.size-full": {},
                    "&.fullwidth": { width: "100%" },
                    "@media (max-width: 420px)": {
                        width: forceMobileImageFullWidth ? "100% !important" : "initial",
                    },
                },
                ".inline-block": {
                    img: { "@media (max-width: 420px)": { width: "auto !important" } },
                },
                ".table-wrapper, .block-parameters-table": {
                    flex: 1,
                    overflowX: "auto",
                    margin: "0 0 10px",
                    width: "100%",
                    "@media (min-width: 768px)": {
                        overflowX: "auto",
                        mb: "0",
                        width: "100%",
                        maxWidth: "100%",
                    },
                },
                "table, .table": {
                    ...theme_1.mui.typography[p],
                    display: "table",
                    position: "relative",
                    zIndex: 2,
                    borderCollapse: ["separate", "collapse"],
                    borderSpacing: "2px",
                    ml: "0",
                    marginRight: "0",
                    marginTop: "1.6rem",
                    paddingBottom: "0",
                    paddingLeft: "0",
                    paddingRight: "0",
                    paddingTop: "0",
                    mb: "1.6rem",
                    fontSize: ["1rem", "12px"],
                    lineHeight: ["1.6rem", 1.1],
                    width: "100%",
                    borderRadius: "20px",
                    overflow: "hidden",
                    li: { mb: "5px", fontSize: "12px" },
                },
                "tr, .tr": {
                    display: "table-row",
                    verticalAlign: "inherit",
                    borderColor: "inherit",
                    "&:nth-of-type(odd)": { background: "#394857" },
                    "&:nth-of-type(even)": { background: "#25323d" },
                },
                "td, .td, th, .th": {
                    display: "table-cell",
                    verticalAlign: "top",
                    borderLeft: "2px solid #1c2832",
                    borderRight: "2px solid #1c2832",
                    textAlign: "center",
                    fontFeatureSettings: "'tnum'",
                    paddingLeft: "1.06667rem",
                    paddingRight: "1.06667rem",
                    paddingTop: "0.8rem",
                    paddingBottom: "calc(0.8rem - 1px)",
                    "&:first-of-type": { borderLeft: "none" },
                    "&:last-of-type": { borderRight: "none" },
                },
                th: { background: "#101a20" },
                "th:first-of-type, .th:first-of-type, td:first-of-type, .td:first-of-type": { paddingLeft: "0.8rem" },
                ".iframe-wrapper": {
                    overflow: "hidden",
                    paddingTop: "56.25%",
                    position: "relative",
                    zIndex: 2,
                },
                ".iframe-wrapper iframe": {
                    border: "0",
                    height: "100%",
                    left: "0",
                    position: "absolute",
                    top: "0",
                    width: "100%",
                },
                ...sx,
            } }, (0, html_react_parser_1.default)(contentString, options)),
        react_1.default.createElement(ImageModal_1.default, { index: selectedImageIndex, images: images, onChangeIndex: (index) => setSelectedImageIndex(index) })));
};
exports.default = Textarea;
